// The placeholders of an automatic invoicing reference or comment, which become the draft's month and year.
// Mirrors Tp_Communication.Constant.InvoiceAutomationConstants.MonthPlaceholder / YearPlaceholder — keep in sync.
const InvoiceAutomationPlaceholderEnum = {
  Month: '{Month}',
  Year: '{Year}',
};

export default InvoiceAutomationPlaceholderEnum;
